// src/PPFCalculator.js
import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const PPFCalculator = () => {
  const [yearlyInvestment, setYearlyInvestment] = useState(150000);
  const [timePeriod, setTimePeriod] = useState(15);
  const [rateOfInterest, setRateOfInterest] = useState(7.1);
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [maturityValue, setMaturityValue] = useState(0);

  const calculateMaturity = () => {
    let totalInvestment = yearlyInvestment * timePeriod;
    let maturityValue = 0;

    for (let i = 0; i < timePeriod; i++) {
      maturityValue = (maturityValue + yearlyInvestment) * (1 + rateOfInterest / 100);
    }

    let totalInterest = maturityValue - totalInvestment;

    setTotalInvestment(totalInvestment);
    setTotalInterest(totalInterest);
    setMaturityValue(maturityValue.toFixed(2));
  };

  const handleYearlyInvestmentChange = (e) => {
    const value = e.target.value;
    setYearlyInvestment(value === '' ? 0 : parseInt(value));
  };

  const handleTimePeriodChange = (e) => {
    const value = e.target.value;
    setTimePeriod(value === '' ? 0 : parseInt(value));
  };

  const handleRateOfInterestChange = (e) => {
    const value = e.target.value;
    setRateOfInterest(value === '' ? 0 : parseFloat(value));
  };

  const data = {
    labels: ['Total Investment', 'Total Interest', 'Maturity Value'],
    datasets: [
      {
        label: 'PPF Breakdown',
        data: [totalInvestment, totalInterest, maturityValue],
        backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'What is the maturity period of a PPF account?',
        answer: '15 years, extendable in 5-year blocks.',
      },
      {
        question: 'Can I make monthly investments in PPF?',
        answer: 'Yes, up to 12 deposits in a year are allowed.',
      },
      {
        question: 'Is the interest earned on PPF taxable?',
        answer: "No, it's completely tax-free under Section 10.",
      },
      {
        question: 'Can I withdraw money before 15 years?',
        answer: 'Partial withdrawals are allowed after 6 years.',
      },
      {
        question: 'How accurate is the PPF calculator?',
        answer: 'It provides a close estimate based on consistent inputs and the prevailing interest rate.',
      },
      {
        question: 'How is interest calculated in a PPF account?',
        answer: 'Monthly basis, but compounded annually.',
      },
      {
        question: 'Can I open multiple PPF accounts?',
        answer: 'No, only one PPF account is allowed per individual.',
      },
      {
        question: 'Can NRIs open a PPF account?',
        answer: 'No, only Indian residents are eligible.',
      },
      {
        question: 'What is the minimum deposit in PPF?',
        answer: '₹500 per year.',
      },
      {
        question: 'What is the maximum deposit allowed?',
        answer: '₹1.5 lakh in a financial year.',
      },
      {
        question: 'Can I take a loan against my PPF balance?',
        answer: 'Yes, from the 3rd to the 6th year.',
      },
      {
        question: 'What happens if I miss a deposit in a year?',
        answer: 'The account becomes inactive and can be reactivated with a penalty.',
      },
      {
        question: 'Is the maturity amount guaranteed?',
        answer: 'Yes, as it is backed by the Government of India.',
      },
      {
        question: 'How do I extend my PPF account after 15 years?',
        answer: 'Submit Form H within a year of maturity.',
      },
      {
        question: 'Is it better to invest monthly or annually in PPF?',
        answer: 'Monthly investments before the 5th yield better overall returns due to monthly interest calculation.',
      },
    ];
    
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>PPF Calculator – Public Provident Fund Interest & Maturity</title>
        <meta  name='description' content='Use our PPF calculator to estimate interest earned and maturity value of your Public Provident Fund investments.'/>
        <meta name='keywords' content='ppf calculator post office, ppf interest rate in sbi,post office public provident fund calculator, post ppf calculator' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/ppf-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">PPF Calculator</span>
        </li> 
      
      </ol>
    </nav> */}

<div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
    <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md ">
      <h1 className="text-2xl font-bold mb-4">PPF Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Yearly Investment</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="150000"
                value={yearlyInvestment}
                onChange={handleYearlyInvestmentChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {yearlyInvestment.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="150000"
              value={yearlyInvestment}
              onChange={(e) => setYearlyInvestment(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Time Period (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="1"
                max="50"
                value={timePeriod}
                onChange={handleTimePeriodChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{timePeriod} Yr</span>
            </div>
            <input
              type="range"
              min="1"
              max="50"
              value={timePeriod}
              onChange={(e) => setTimePeriod(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (%)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="15"
                step="0.1"
                value={rateOfInterest}
                onChange={handleRateOfInterestChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{rateOfInterest} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={rateOfInterest}
              onChange={(e) => setRateOfInterest(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateMaturity}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Total Investment: ₹ {totalInvestment.toLocaleString()}</p>
            <p>Total Interest: ₹ {totalInterest.toLocaleString()}</p>
            <p>Maturity Value: ₹ {maturityValue.toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is a PPF Account?
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            A Public Provident Fund account is a long-term savings scheme introduced by the National Savings Institute in 1968. It is a risk-free investment vehicle that encourages individuals to build a secure corpus over a 15-year lock-in period. The government decides the interest rate quarterly, and the earned interest is compounded annually and is fully tax-free under Section 10 of the Income Tax Act.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Key Features:
          </p>
          <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
            <li>Minimum investment: ₹500 per year</li>
            <li>Maximum investment: ₹1.5 lakh per financial year</li>
            <li>Lock-in period: 15 years (can be extended in 5-year blocks)</li>
            <li>Interest: Compounded annually and declared quarterly by the government</li>
            <li>Tax benefits: Eligible for deductions under Section 80C up to ₹1.5 lakh annually</li>
          </ul>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Who Should Consider a PPF Account?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              PPF is ideal for individuals looking for guaranteed returns and long-term wealth accumulation. It’s especially beneficial for:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Salaried Employees:</strong> Looking to create a retirement corpus with tax benefits.</li>
              <li><strong>Parents:</strong> Saving for a child's education, marriage, or other major life goals.</li>
              <li><strong>Self-employed Professionals:</strong> Who want to invest without market volatility.</li>
              <li><strong>Risk-Averse Investors:</strong> Looking for safe and predictable returns.</li>
              <li><strong>Senior Citizens (Post 60):</strong> Continuing investments with extended tenure for estate planning or health security.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use a PPF Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A PPF calculator takes the guesswork out of your long-term investment journey. By inputting just a few variables, you can understand how your money will grow over time.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Benefits of Using a PPF Calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Accurate Estimation:</strong> Predict your maturity amount based on annual contributions and tenure.</li>
              <li><strong>Helps in Tax Planning:</strong> Understand how much tax you can save each year under Section 80C.</li>
              <li><strong>Investment Flexibility:</strong> Choose your investment pattern—yearly or monthly—and see its impact.</li>
              <li><strong>Informed Decision-Making:</strong> Visualize different scenarios to plan better for your financial goals.</li>
              <li><strong>Goal Tracking:</strong> Align your PPF maturity amount with future expenses like retirement or education.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does a PPF Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A PPF calculator uses a compound interest formula that takes into account the annual deposit, interest rate, and tenure. The formula used is:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>F = P [((1+i)^n - 1) / i]</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>F</strong> = Final amount (Maturity)</li>
              <li><strong>P</strong> = Annual contribution</li>
              <li><strong>i</strong> = Interest rate / 100</li>
              <li><strong>n</strong> = Number of years</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Example Calculation: If you invest ₹1,50,000 annually for 15 years at an interest rate of 7.1%, your maturity value would be approximately ₹40,68,209.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Understanding the Components of the Formula
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              1. <strong>Investment Amount (P)</strong>
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The annual or monthly amount you choose to contribute. You can invest a lump sum or in multiple installments, with a minimum of ₹500 and a maximum of ₹1.5 lakh annually.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              2. <strong>Interest Rate (i)</strong>
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Declared quarterly by the Ministry of Finance, the interest rate is compounded yearly and credited on March 31st.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              3. <strong>Investment Tenure (n)</strong>
            </p>
            <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The PPF scheme has a default tenure of 15 years, but it can be extended indefinitely in 5-year blocks with or without additional contributions.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Sample Year-by-Year Growth Table
            </h2>
            {/* <div className="overflow-x-auto mt-4">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-4 py-2 text-left">Year</th>
                    <th className="px-4 py-2 text-left">Opening Balance</th>
                    <th className="px-4 py-2 text-left">Annual Investment</th>
                    <th className="px-4 py-2 text-left">Interest Earned</th>
                    <th className="px-4 py-2 text-left">Closing Balance</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 text-gray-600">
                  <tr>
                    <td className="px-4 py-2">1</td>
                    <td className="px-4 py-2">₹0</td>
                    <td className="px-4 py-2">₹1,50,000</td>
                    <td className="px-4 py-2">₹11,400</td>
                    <td className="px-4 py-2">₹1,61,400</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">2</td>
                    <td className="px-4 py-2">₹1,61,400</td>
                    <td className="px-4 py-2">₹1,50,000</td>
                    <td className="px-4 py-2">₹23,666</td>
                    <td className="px-4 py-2">₹3,35,066</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">3</td>
                    <td className="px-4 py-2">₹3,35,066</td>
                    <td className="px-4 py-2">₹1,50,000</td>
                    <td className="px-4 py-2">₹36,865</td>
                    <td className="px-4 py-2">₹5,21,931</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">15</td>
                    <td className="px-4 py-2">₹38,45,982</td>
                    <td className="px-4 py-2">₹1,50,000</td>
                    <td className="px-4 py-2">₹2,22,227</td>
                    <td className="px-4 py-2">₹40,68,209</td>
                  </tr>
                </tbody>
              </table>
            </div> */}

            <div className="max-w-4xl mx-auto overflow-hidden rounded-lg border border-gray-300 shadow mt-6">
    {/* Header */}
    <div className="hidden md:grid grid-cols-5 bg-gray-800 text-white text-sm font-semibold text-center">
    <div className="px-3 py-2 border-r">Year</div>
     
      <div className="px-3 py-2 border-r">Opening Balance</div>
      <div className="px-3 py-2 border-r">Annual Investment</div>
      <div className="px-3 py-2  border-r">Interest Earned</div>
      <div className="px-3 py-2">Closing Balance</div>
    </div>

    {/* Data rows for mobile (stacked) and desktop (grid) */}
    <div className="divide-y divide-gray-200 text-sm md:text-base text-gray-600 ">
      {/* Row Template */}
      {[
        {
          year:"1",
          open: "₹0",
          annual: "₹1,50,000",
          interest: "₹11,400",
          closing: "	₹1,61,400",
        
        },
        {
          year:"2",
          open: "	₹1,61,400",
          annual: "₹1,50,000",
          interest: "₹23,666",
          closing: "₹3,35,066",
        
        },
        {
          year:"3",
          open: "₹3,35,066",
          annual: "₹1,50,000",
          interest: "₹36,865",
          closing: "₹5,21,931",
        
        },
        {
          year:"4",
          open: "	₹38,45,982",
          annual: "₹1,50,000",
          interest: "	₹2,22,227",
          closing: "₹40,68,209",
        
        },
     
        
        
      
      ].map((row, idx) => (
        <div
          key={idx}
          className="block md:grid md:grid-cols-5 hover:bg-gray-50 transition"
        >
          {/* Mobile version */}
          <div className="block md:hidden px-4 py-3">
            <p className="font-semibold">Year: <span className="font-normal">{row.year}</span></p>
            <p className="font-semibold">Opening Balance: <span className="font-normal">{row.open}</span></p>
            <p className="font-semibold">Annual Investment: <span className="font-normal">{row.annual}</span></p>
            <p className="font-semibold">Interest Earned: <span className="font-normal">{row.interest}</span></p>
            <p className="font-semibold">Closing Balance: <span className="font-normal">{row.closing}</span></p>

          </div>

          {/* Desktop version */}
          <div className="hidden md:block px-4 py-3 border-r">{row.year}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.open}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.annual}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.interest}</div>

          <div className="hidden md:block px-4 py-3">{row.closing}</div>

        </div>
      ))}
    </div>
  </div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Monthly vs Annual Investment in PPF
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              While PPF allows both lump sum and installment-based investments, the interest is calculated monthly but credited annually. To maximize returns:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Invest before the 5th of each month to gain full interest for that month.</li>
              <li>Consistent monthly investments create better financial discipline.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How to Use a PPF Calculator: Step-by-Step
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using the calculator is simple and intuitive. Here's how to go about it:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Select Investment Frequency:</strong> Choose between monthly or annual deposits.</li>
              <li><strong>Enter Amount:</strong> Provide the amount you plan to invest regularly.</li>
              <li><strong>Input Tenure:</strong> Default is 15 years, but you can check for extended scenarios.</li>
              <li><strong>Specify Interest Rate:</strong> Use the current applicable PPF rate (7.1% as of May 2024).</li>
              <li><strong>View Results:</strong> The calculator will instantly show your total contribution, interest earned, and maturity amount.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using a PPF Calculator
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Saves Time and Effort – No need for manual calculations.</li>
              <li>Accurate Results – Uses standard formulas and updated rates.</li>
              <li>Helps You Plan for Goals – Know exactly how much to invest for your desired corpus.</li>
              <li>Tax Efficiency – Maximize savings under 80C.</li>
              <li>Visual Financial Roadmap – Understand yearly growth and interest accumulation.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Things to Know Before Using a PPF Calculator
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>The calculator assumes consistent annual or monthly contributions.</li>
              <li>Interest rates may vary every quarter.</li>
              <li>Early withdrawals and loans can affect your final maturity amount.</li>
              <li>Contributions must be within the minimum and maximum annual limits.</li>
              <li>Partial withdrawals allowed only from the 7th year onward.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              PPF Account Options Across India
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              You can open a PPF account with:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>State Bank of India (SBI)</li>
              <li>HDFC Bank</li>
              <li>ICICI Bank</li>
              <li>Union Bank of India</li>
              <li>Canara Bank</li>
              <li>Post Offices</li>
              <li>Bank of India</li>
              <li>Indian Bank</li>
              <li>Central Bank of India</li>
              <li>IDBI Bank</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              All offer online account management, nomination options, and extension facilities.
            </p>
          </div>

          <h2 className="text-xl font-medium text-gray-700 mt-4">
            “Looking to invest? Open an account with TheFinMaster and start building your wealth with Public Provident Fund!”
          </h2>
        </div>
        <div className="w-full md:w-1/3 p-4">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
              <h2 className="text-lg font-semibold ">Popular Categories</h2>
            </div>
            <div className="p-2 ">
            <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                        {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                {/* {moreCategories.map(category => (
          <Link key={category.id} to={`/category/${category.id}`}>
            <li className="py-2 border-b border-gray-300">{category.name}</li>
          </Link>
        ))} */}
              </ul>
            </div>
          </div>

        </div>

      </div>
      <div className="max-w-4xl mx-auto py-6 mt-10 px-2">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default PPFCalculator;
